import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/Images/ncs-logo.svg";
import { setloadTost } from "../redux/slices/toastSlice";
import {
  createStudentApplicationForm,
  // editStudentApplicationForm,
  fetchStudentApplication,
} from "../redux/slices/studentRegistrationSlice";
import { removeUser } from "../redux/slices/authSlice";
import { generateStudentFormData } from "../components/generateStudentFormData";
import StudentApplicationFormHeader from "../components/StudentApplicationFormHeader";
import StudentPersonalInformationAppForm from "../components/StudentPersonalInformationAppForm";
import StudentMarriageForm from "../components/StudentMarriageForm";
import StudentMarriageRefereeInformationAppForm from "../components/StudentMarriageRefereeInformationAppForm";
import { useBreakpointValue } from "@chakra-ui/react";

const StudentApplicationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({});
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saveloading, setSaveloading] = useState(false);
  const [error, setError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [approved, setApproved] = useState(false);
  const [declined, setDeclined] = useState(false);
  const [comment, setComment] = useState("");
  const [formSave, setFormSave] = useState(false);
  const [noData, setNoData] = useState(false);
  // const userType = useSelector((state) => state.auth);

  const errorsArray = Array.isArray(error) ? error : [error];
  // const max = 2; // number of steps

  const signOut = () => {
    dispatch(removeUser());
    localStorage.removeItem("persist:root");
    navigate("/");
  };

  const handleNext = (data) => {
    setFormData((prev) => ({ ...prev, ...data }));
    setActiveStep((prev) => Math.min(prev + 1, max));
  };

  const handlePrevious = () => {
    setActiveStep((prev) => Math.max(prev - 1, 0));
  };

  // console.log("Current UserType: ", userType);
  const getRegisteredIndividual = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await dispatch(fetchStudentApplication());
      if (response?.payload?.data?.isSuccess === true) {
        if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Pending"
        ) {
          setLoading(false);
          setSubmitted(true);
        } else if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Approved"
        ) {
          setLoading(false);
          setApproved(true);
        } else if (
          response?.payload?.data?.isSubmitted === true &&
          response?.payload?.data?.status === "Declined"
        ) {
          setLoading(false);
          setDeclined(true);
          setComment(response?.payload?.data?.comment);
        } else if (response?.payload?.data?.isSubmitted === false) {
          setLoading(false);
          setFormSave(true);
        }
      } else {
        if (response?.payload?.response?.status === 404) {
          setLoading(false);
          setNoData(true);
        } else if (response?.payload?.response?.status === 401) {
          dispatch(removeUser());
          localStorage.removeItem("persist:root");
          navigate("/");
        } else {
          setLoading(false);
          setError(
            response?.payload?.response?.data?.errors?.map(
              (errors) => errors
            ) ||
              response?.payload?.response?.data?.error?.description ||
              "Failed to get Applicaion Form, please check your request/network"
          );
        }
      }
    } catch (error) {
      setError(
        error?.payload?.message ||
          "Failed to get Applicaion Form, please check your request/network"
      );
    } finally {
      setLoading(false);
    }
  }, [dispatch, navigate]);

  useEffect(() => {
    getRegisteredIndividual();
  }, [getRegisteredIndividual]);

  const handleSubmitOrSave = async (data, isFinalSubmit = true) => {
    const updatedFormData = { ...formData, ...data };
    setFormData(updatedFormData);

    try {
      const studentFormData = await generateStudentFormData(
        updatedFormData,
        isFinalSubmit
      );
      isFinalSubmit ? setLoading(true) : setSaveloading(true);
      setError("");

      const response = await dispatch(
        // isFinalSubmit ?
        createStudentApplicationForm(studentFormData)
        // : editStudentApplicationForm(studentFormData)
        // console.log("studentFormData: ", studentFormData)
      );
      // console.log("Response: ", response);

      if (response?.payload?.isSuccess) {
        dispatch(
          setloadTost({
            title: "Application Submitted",
            description: "Student Application submitted successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
            position: "top",
          })
        );
        if (isFinalSubmit) navigate("/");
      } else {
        setError(
          response?.payload?.errors?.join(", ") ||
            response?.payload?.error?.description ||
            "Failed to process the application"
        );
      }
    } catch (error) {
      setError(error?.message || "Network error, please try again");
    } finally {
      isFinalSubmit ? setLoading(false) : setSaveloading(false);
    }
  };

  const steps = [
    {
      title: "Personal Information",
      form: <StudentPersonalInformationAppForm handleNext={handleNext} />,
    },
    {
      title: "Marital Information",
      form: (
        <StudentMarriageForm
          handlePrevious={handlePrevious}
          handleNext={handleNext}
        />
      ),
    },
    {
      title: "Referee Information",
      form: (
        <StudentMarriageRefereeInformationAppForm
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleSubmit={(data) => handleSubmitOrSave(data, true)}
          handleSaveRegLater={(data) => handleSubmitOrSave(data, false)}
          loading={loading}
          saveloading={saveloading}
        />
      ),
    },
  ];
  const max = steps.length - 1;
  const progressPercent = (activeStep / max) * 100;
  const orientation = useBreakpointValue({
    base: "vertical",
    md: "vertical",
    lg: "horizontal",
  });

  const appData = {
    logo,
    signOut,
    error,
    errorsArray,
    steps,
    activeStep,
    setActiveStep,
    progressPercent,
    orientation,
    submitted,
    formSave,
    noData,
    formData,
    approved,
    declined,
    comment,
  };

  return <StudentApplicationFormHeader {...appData} />;
};

export default StudentApplicationForm;
